import { render, staticRenderFns } from "./MessageLeaders.vue?vue&type=template&id=40ba0f23&"
import script from "./MessageLeaders.vue?vue&type=script&lang=js&"
export * from "./MessageLeaders.vue?vue&type=script&lang=js&"
import style0 from "./MessageLeaders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports